<template>
    <v-card class="push" elevation="1" @click="open">
        <v-row no-gutters>
            <v-col cols="3">
                <div class="title-wrapper">
                    <typo name="title-18-bold">{{ push.subject }}</typo>
                    <sep name="S" />
                    <typo name="body-14-light">{{ sentAt }}</typo>
                </div>
            </v-col>
            <v-col cols="9">
                <div class="content-wrapper">
                    <typo name="body-16-light max-3-lines">{{ body }}</typo>
                </div>
            </v-col>
        </v-row>
    </v-card>
</template>

<script>
import { Services } from "src/services/Services";
import { EventBus } from "src/bus/eventBus";

export default {
    props: ["push"],
    methods: {
        open() {
            EventBus.$emit("push-popin:show", this.push.id);
        },
    },
    computed: {
        sentAt() {
            return Services.moment(this.push.sentAt).format("LLL");
        },
        body() {
            const div = document.createElement("div");
            div.innerHTML = this.push.body;
            return div.textContent || div.innerText || "";
        },
    },
};
</script>

<style scoped lang="sass">
.push
    margin: 10px 0
.title-wrapper
    padding: 16px
.content-wrapper
    padding: 16px
.max-3-lines
    display: inline-block
    overflow: hidden
    max-height: 3.8em
    line-height: 1.4em
</style>
